import { Alert, Button, Form, Table, Tag, Tooltip } from "antd";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useTranslation } from "react-i18next";
import { PrinterOutlined } from "@ant-design/icons";
import React, {  useContext, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import GlobalContext from "../../../../../context/GlobalContext";
import { calculerPeriodesCalendrier } from "../../../../../api/geoprod";
import { useLoader } from "../../../../../context/LoaderContext";
dayjs.extend(duration);

const EtapeRepartitionChronologique = ({ globalData,setGlobalData,print }) => {
  const printRef = useRef();
    const {orderedConflicts} =  useContext(GlobalContext);
      const {isLoading, setIsLoading } = useLoader();
  const { t } = useTranslation();
  const formValues = globalData;
  const modules = globalData?.modules_formation || [];
  const plagesMultiple = {
    stage: [
      formValues.periode_stage_integration && {
        stage_integration: {
          start: formValues.periode_stage_integration.start,
          end: formValues.periode_stage_integration.end,
        },
        stageType: "intégration",
      },
      formValues.periode_stage_obseravation && {
        stage_observation: {
          start: formValues.periode_stage_obseravation.start,
          end: formValues.periode_stage_obseravation.end,
        },
        stageType: "observation",
      },
    ].filter(Boolean),
    examen: (formValues.semaines_examen?.[0]?.items || []).filter(
      (item) => item.examen_oui === "Oui"
    ),
    vacances: (formValues.semaines_vacances?.[0]?.items || []).filter(
      (v) => v && typeof v === "object"
    ),
    rattrapage: (formValues.semaines_examen?.[0]?.items || []).filter(
      (item) => item.ratrapage_oui === "Oui"
    ),
  };
  const insertSpecialLines = (weeksData, plagesMultiple, orderedConflicts) => {
    const result = [];
    const insertedKeys = new Set();
    const nbrePeriode = parseInt(globalData?.nbre_periode, 10);
    const periodesParAn = globalData?.type_periode === "Semestrielle" ? 2 : 3;
    const semainesParPeriode = [];
    for (let i = 1; i <= nbrePeriode; i++) {
      const semaines = parseInt(
        globalData[`nbre_semaines_periode_${i}`] || 0,
        10
      );
      semainesParPeriode.push(semaines);
    }
    const getPeriodeLabel = (weekIndex) => {
      let cumul = 0;
      for (let i = 0; i < semainesParPeriode.length; i++) {
        cumul += semainesParPeriode[i];
        if (weekIndex < cumul) {
          const prefix = globalData?.type_periode === "Semestrielle" ? "Semestre" : "Trimestre";
          return `${prefix} ${i + 1}`;
        }
      }
      return "";
    };


    let currentWeekIndex = 0;
    for (
      let periodeIndex = 0;
      periodeIndex < semainesParPeriode.length;
      periodeIndex++
    ) {
      if (periodeIndex % periodesParAn === 0) {
        const yearNumber = Math.floor(periodeIndex / periodesParAn) + 1;
        result.push({
          type: "year",
          key: `year-${yearNumber}`,
          yearLabel: `${yearNumber}${yearNumber === 1 ? "ère" : "ème"} Année`,
        });
      }
       const semaines = semainesParPeriode[periodeIndex];
      const rowData = weeksData[currentWeekIndex]
        ? weeksData[currentWeekIndex]
        : {};
      const modulesStructred = [];
      let chargeHebdo = 0;

      const refModules = modules[0]?.items || [];
      let indexMG = 1;
      let indexMS = 1;

      for (const [label, value] of Object.entries(rowData)) {
        if (typeof value !== "number") continue;

        // vérifier si ce module est référencé
        const refModule = refModules.find((m) => m.intitulé[0] === label);
        if (!refModule) continue;

        const type = refModule.type;
        const code = type === "Général" ? `MG ${indexMG++}` : `MS ${indexMS++}`;

        modulesStructred.push({  id_module:code ,name_module:label, nb_heures:`${value} h`});
        chargeHebdo += value;
      }

      // const semaines = semainesParPeriode[periodeIndex];
      for (let j = 0; j < semaines; j++) {
        const periode = getPeriodeLabel(currentWeekIndex);
        const row = {
          ...weeksData[currentWeekIndex],
          type: "normal",
          weekIndex: currentWeekIndex,
          modulesStructred,
          chargeHebdo,
          periode,
        };
        result.push(row);
        const specialEntries = [];
        for (const [type, plages] of Object.entries(plagesMultiple)) {
          for (const plage of plages) {
            // let periode = null;
            let periodeObj = null;
            if (type === "stage") {
              periodeObj = Object.values(plage).find(
                (val) =>
                  val &&
                  typeof val === "object" &&
                  val.start === currentWeekIndex
              );
            } else if (type === "examen" || type === "rattrapage") {
              const key =
                type === "examen" ? "periode_examen" : "periode_rattrapage";
              if (plage[key]?.start === currentWeekIndex) {
                periodeObj = plage[key];
              }
            } else if (type === "vacances") {
              if (plage.periode_vacances?.start === currentWeekIndex) {
                periodeObj = plage.periode_vacances;
              }
            }
            if (periodeObj) {
              const uniqueKey = `${periodeObj.start}-${periodeObj.end}-${type}`;
              if (!insertedKeys.has(uniqueKey)) {
                insertedKeys.add(uniqueKey);
                specialEntries.push({
                  specialType: type,
                  label: {
                    examen: "Période d'évaluation",
                    rattrapage: "Période de rattrapage",
                    vacances: "Vacances",
                    stage: `Stage ${plage.stageType || ""}`,
                  }[type],
                  start: periodeObj.start,
                  end: periodeObj.end,
                  duration: periodeObj.end - periodeObj.start + 1,
                  plageData: plage,
                });
              }
            }
          }
        }
        const conflictKey = `${currentWeekIndex}-${currentWeekIndex + 1}`;
        let finalList = [];
        if (orderedConflicts && orderedConflicts[conflictKey]) {

          finalList = orderedConflicts[conflictKey]
            .map(({ type, data }) =>
              specialEntries.find(
                (e) =>
                  e.specialType === type &&
                  e.start === data.start &&
                  e.end === data.end
              )
            )
            .filter(Boolean);
        } else {
          const priority = { examen: 1, rattrapage: 2, vacances: 3, stage: 4 };
          finalList = specialEntries.sort((a, b) => {
            if (a.start !== b.start) return a.start - b.start;
            return (
              (priority[a.specialType] || 99) - (priority[b.specialType] || 99)
            );
          });
        }
        for (const entry of finalList) {
          if (!entry.specialType || !entry.label) {
            console.warn("⚠️ Ligne spéciale ignorée car incomplète :", entry);
            continue;
          }

          result.push({
            type: "special",
            specialType: entry.specialType,
            label: entry.label,
            startWeek: entry.start,
            weekIndex: null,
            duration: entry.duration,
            typeStage: entry.plageData,
            periode: getPeriodeLabel(entry.start),
          });
        }
        currentWeekIndex++;
      }
    }
    return result;
  };
  const [transformedDataStages, setTransformedDataStages] = useState(JSON.parse(sessionStorage.getItem("globalData"))?.transformedDataStages ? JSON.parse(sessionStorage.getItem("globalData"))?.transformedDataStages : insertSpecialLines(
    globalData?.newData,
    plagesMultiple,
    orderedConflicts
  ))
  
  // let transformedDataStages = insertSpecialLines(
  //   globalData?.newData,
  //   plagesMultiple,
  //   orderedConflicts
  // );

    const recapModulesColumns = [
      {
        title: t("Période"),
        dataIndex: "periode",
        render: (_, row) => {
          if (row.type === "year") {
            return {
              children: null,
              props: { rowSpan: 0 },
            };
          }
  
          if (row.type === "special") {
            return { children: null, props: { rowSpan: 0 } };
          }
  
          const type = globalData["type_periode"];
  
          const semainesParPeriodeList = [];
          let i = 1;
          while (true) {
            const value = parseInt(
              globalData[`nbre_semaines_periode_${i}`]
            );
            if (isNaN(value)) break;
            semainesParPeriodeList.push(value);
            i++;
          }
  
          const weekIndex = row.weekIndex;
  
          let cumulative = 0;
          let periodeIndex = -1;
  
          for (let j = 0; j < semainesParPeriodeList.length; j++) {
            cumulative += semainesParPeriodeList[j];
            if (weekIndex < cumulative) {
              periodeIndex = j;""
              break;
            }
          }
  
          if (periodeIndex === -1)
            return { children: null, props: { rowSpan: 0 } };
  
          const periodeNom =
            type === "Semestrielle"
              ? `Semestre ${periodeIndex + 1}`
              : `Trimestre ${periodeIndex + 1}`;
  
          const debutPeriode = semainesParPeriodeList
            .slice(0, periodeIndex)
            .reduce((a, b) => a + b, 0);
  
          const finPeriode =
            debutPeriode + semainesParPeriodeList[periodeIndex] - 1;
  
          const lignesDansPeriode = transformedDataStages.filter((r) => {
            const idx =
              typeof r.weekIndex === "number" ? r.weekIndex : r.startWeek;
            return idx >= debutPeriode && idx <= finPeriode;
          });
  
          const isFirstRow = row.weekIndex === debutPeriode;
  
          if (isFirstRow) {
            return {
              children: periodeNom,
              props: {
                rowSpan: lignesDansPeriode.length,
              },
            };
          }
  
          return { children: null, props: { rowSpan: 0 } };
        },
        // width:120
      },
      {
        title: "Semaine",
        dataIndex: "week",
        render: (value, row) => {
          if (row.type === "year") {
            return {
              children: (
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 16,
                    textAlign: "center",
                  }}
                >
                  {row.yearLabel}
                </div>
              ),
              props: {
                colSpan: recapModulesColumns.length, // toute la largeur
              },
            };
          }
  
          if (row.type === "special") {
            const tagColors = {
              stage: "blue",
              examen: "red",
              rattrapage: "gold",
              vacances: "orange",
            };
  
            const tagColor = tagColors[row.specialType] || "default";
  
            return {
              children: <Tag color={tagColor}>{row.label}</Tag>,
              props: {},
            };
          }
  
          return "Semaine formation N°" + value;
        },
      },
      {
        title: "Date de début",
        dataIndex: "date_debut_periode",

      },
      {
        title: "Date de fin",
        dataIndex: "date_fin_periode",
      },
  
      ...(modules?.[0]?.items || []).map((mod, index) => ({
        title: <Tooltip title={mod?.intitulé}>{`M${
          mod?.type === "Général"
            ? import.meta.env.VITE_APP_TYPE_MODULE_GENERAL
            : import.meta.env.VITE_APP_TYPE_MODULE_SPECIFIQUE
        }${index + 1}`}</Tooltip>,
        dataIndex: mod?.intitulé,
        render: (_, row) => {
          if (row.type === "year") {
            return {
              children: null,
              props: { colSpan: 0, style: { display: "none" } },
            };
          }
          if (row.type === "special") {
            return { children: null, props: { colSpan: 0 } };
          }
          const semaineIndex = row.weekIndex + 1;
          const value = globalData?.[`${mod.intitulé}${semaineIndex}`] || 0;
          return `${value} h`;
        },
      })),
      {
        title: "Charge hebdo",
        render: (_, row) => {
          if (row.type === "year") {
            return {
              children: null,
              props: { colSpan: 0, style: { display: "none" } },
            };
          }
  
          if (row.type === "special") {
            const iconMap = {
              stage: "🟦",
              examen: "🟥",
              rattrapage: "🟨",
              vacances: "🟧",
            };
  
            const labelMap = {
              stage: "Stage",
              examen: "Évaluation",
              rattrapage: "Rattrapage",
              vacances: "Vacances",
            };
            const specialType = row.specialType.includes("periode_")
              ? row.specialType.replace("periode_", "")
              : row.specialType;
  
            const icon = iconMap[specialType] || "⬜";
            const label = labelMap[specialType] || specialType;
  
            const plages = plagesMultiple?.[specialType] || [];
            const plage = plages.find((p) => {
              const periode = Object.values(p).find(
                (val) =>
                  val && typeof val === "object" && val.start === row.startWeek
              );
              return !!periode;
            });
  
            let suffix = "";
            if (specialType === "stage") {
              const stageType = row.typeStage || plage?.stageType || "";
              const nbSemaines =
                stageType.stageType === "intégration"
                  ? globalData?.duree_stage_mois_observation * 4
                  : stageType.stageType === "observation"
                  ? globalData?.duree_stage_mois_integration * 4
                  : undefined;
  
              suffix = nbSemaines
                ? ` – ${stageType.stageType} – ${nbSemaines} ${
                    nbSemaines > 1 ? "semaines" : "semaine"
                  }`
                : ` – ${stageType}`;
            } else {
              let nbreJours = 0;
              if (specialType === "vacances") {
                nbreJours = plage?.nbre_vacances_periode || 0;
              } else if (specialType === "rattrapage") {
                nbreJours = plage?.nbre_rattrapage_periode || 0;
              } else if (specialType === "examen") {
                nbreJours = plage?.nbre_examen_periode || 0;
              }
  
              suffix = nbreJours ? ` – ${nbreJours} jours` : "";
            }
  
            return {
              children: (
                <strong style={{ display: "block", textAlign: "center" }}>
                  {`${icon} ${label}${suffix}`}
                </strong>
              ),
              props: {
                colSpan: recapModulesColumns.length,
              },
            };
          }
          let total = 0;
  
          // Additionner les heures stockées par semaine pour chaque module
          modules[0]?.items.forEach((mod) => {
            const semaineVal =
              globalData?.[`${mod.intitulé}${row.week}`] ||
              row[mod.intitulé] ||
              0;
            total += typeof semaineVal === "number" ? semaineVal : 0;
          });
  
          return `${total} h`;
        },
      },
    ];

    useEffect(() => {
  if (transformedDataStages?.length && print && sessionStorage.getItem("consulter") !== "true" )  {
    setIsLoading(true);
    const filteredRows = transformedDataStages.filter(row => row?.type !== "year");

    const payload = {
      date_debut_session: formValues?.date_debut_session_formation,
      periodes: filteredRows.map((row) => {
        if (row?.type === "normal") {
          return {
            type: "normal",
            durationWeek: 1,
          };
        }

        if (row?.type === "special") {
          if (row?.specialType === "stage") {
            const stageType = row?.typeStage;
            const stageLabel = stageType?.stageType;

            const duration =
              stageLabel === "intégration"
                ? Number(globalData?.duree_stage_mois_observation) * 4
                : stageLabel === "observation"
                ? Number(globalData?.duree_stage_mois_integration) * 4
                : 0;

            return {
              type: "special",
              specialType: "stage",
              durationWeek: duration,
            };
          } else {
            const duration =
              row.specialType === "rattrapage"
                ? row?.typeStage?.nbre_rattrapage_periode
                : row.specialType === "examen"
                ? row?.typeStage?.nbre_examen_periode
                : row?.typeStage?.nbre_vacances_periode;

            return {
              type: "special",
              specialType: row?.specialType,
              durationDay: duration,
            };
          }
        }

        return null;
      }),
    };

    calculerPeriodesCalendrier(payload)
      .then((response) => {
        const enrichedData = transformedDataStages.map((item, index) => {
          if (item?.type === "year") {
            return {
              ...item,
              date_debut_periode: "",
              date_fin_periode: "",
            };
          }

          const filteredIndex = filteredRows.indexOf(item);
          const matchingApiData = response?.data?.message?.[filteredIndex];

          return {
            ...item,
            date_debut_periode: matchingApiData?.date_debut || "",
            date_fin_periode: matchingApiData?.date_fin || "",
          };
        });

        setTransformedDataStages(enrichedData);

        const lastRow = [...enrichedData].reverse().find(row => row.date_fin_periode);
        const x = {
          // ...globalData,
             ...JSON.parse(sessionStorage.getItem("globalData")),
          date_fin_session_formation: lastRow?.date_fin_periode,
          transformedDataStages: enrichedData,
        };

        sessionStorage.setItem("globalData", JSON.stringify(x));
        setGlobalData(x);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }
}, []);

    // useEffect(() => {
    //   if (transformedDataStages?.length) {
    //     setIsLoading(true)
    //     const payload = {
    //       date_debut_session: formValues?.date_debut_session_formation,
    //       periodes: transformedDataStages
    //         ?.filter((row) => row?.type !== "year")
    //         ?.map((row) => {
    //           const plage = row.plage;
    
    //           if (row?.type === "normal") {
    //             return {
    //               type: "normal",
    //               durationWeek: 1,
    //             };
    //           }
    
    //           if (row?.type === "special") {
    //             if (row?.specialType === "stage") {
    //               const stageType = row?.typeStage ;
    //               const stageLabel = stageType?.stageType;
    
    //               const duration =
    //                 stageLabel === "intégration"
    //                   ? Number(globalData?.duree_stage_mois_observation) * 4
    //                   : stageLabel === "observation"
    //                   ? Number(globalData?.duree_stage_mois_integration) * 4
    //                   : 0;
    
    //               return {
    //                 type: "special",
    //                 specialType: "stage",
    //                 durationWeek: duration,
    //               };
    //             } else {
    //               const duration = row.specialType === "rattrapage" ? row?.typeStage?.nbre_rattrapage_periode  : 
    //               row.specialType === "examen" ? row?.typeStage?.nbre_examen_periode : row?.typeStage?.nbre_vacances_periode
                   
    //               return {
    //                 type: "special",
    //                 specialType: row?.specialType,
    //                 durationDay: duration,
    //               };
    //             }
    //           }
    
    //           return null;
    //         })
    //     };

    //     calculerPeriodesCalendrier(payload)
    //     .then( (response) => {
    //       const enrichedData = transformedDataStages?.filter((row) => row?.type !== "year")
    //       ?.map((item, index) => {
    //         const matchingApiData = response?.data?.message?.find(period => period.index === index);
          
    //         return {
    //           ...item,
    //           date_debut_periode: matchingApiData?.date_debut ,
    //           date_fin_periode: matchingApiData?.date_fin 
    //         };
    //       });
    //       setTransformedDataStages(enrichedData);

    //       const lastRow = [...enrichedData].reverse().find(row => row.date_fin);
    //       const x = {
    //         ...globalData,
    //         date_fin_session_formation: lastRow?.date_fin,
    //         transformedDataStages: enrichedData,
    //       };
    //       sessionStorage.setItem("globalData", JSON.stringify(x));
    //       setGlobalData(x);
    //       setIsLoading(false)

    //     })
    //     .catch(()=>{
    //       setIsLoading(false)
    //     })
    //   }
    // }, []);
    



  return (
    <div>
        {print && ( <Alert type="info"   
          style={{ marginBlock:"1rem"}}
          message="Configuration"
          description={`                 `}  showIcon />)} 
<div  ref={printRef}>
<Table
  scroll={{ x: "max-content" }}
        style={{ width: "100%" }}
        // loading={isLoading}
        columns={recapModulesColumns}
        dataSource={transformedDataStages.map((item, idx) => ({ key: idx, ...item }))}
        rowClassName={(record) =>
          ["special", "year"].includes(record.type) ? "row-total-colored" : ""
        }
        pagination={false}
      />
</div>
    
{/* <Button
onClick={()=>{
 
  }}
>
  Consulter
</Button> */}


      
  
    </div>
  );
};

export default EtapeRepartitionChronologique;
